export default "__VITE_ASSET__Csgex8_A__"